"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SELECTION_LIMIT = void 0;
var SELECTION_LIMIT = exports.SELECTION_LIMIT = 5;